import React from 'react';
import { alpha, useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import StarIcon from '@mui/icons-material/Star';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import HighQualityIcon from '@mui/icons-material/HighQuality';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

const items = [
  {
    title: 'Autoridad del Ancla',
    subtitle: 'El respaldo del Dr. Julio César López Galea otorga un sello de garantía a sus aliados.',
    Icon: StarIcon,
  },
  {
    title: 'Mercado B2B y B2C',
    subtitle: 'Conexión simultánea con propietarios individuales y juntas que firman contratos corporativos.',
    Icon: BusinessCenterIcon,
  },
  {
    title: 'Innovación Mediática',
    subtitle: 'Somos un Media Lab; tu marca se ve en alta definición y se escucha con la mejor tecnología de streaming.',
    Icon: HighQualityIcon,
  },
  {
    title: 'UGC y Validación Real',
    subtitle: 'Generamos contenido donde mostramos tu producto resolviendo un problema real en un edificio, eliminando la barrera de la "publicidad tradicional".',
    Icon: ThumbUpIcon,
  },
];

const Values = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="textSecondary"
          align="center"
        >
          Ventajas Competitivas
        </Typography>
        <Box component={Typography} fontWeight={700} variant="h3" gutterBottom align="center" color="primary">
          ¿Por qué Dr. Condominio?
        </Box>
      </Box>
      <Grid container spacing={4}>
        {items.map((item, i) => (
          <Grid item xs={12} sm={6} md={6} key={i}>
            <Box component={Card} boxShadow={3} borderRadius={4}>
              <Box
                component={CardContent}
                display="flex"
                flexDirection="column"
                alignItems="center"
                padding={{ xs: 2, sm: 4, md: 6 }}
                sx={{
                  '&:last-child': {
                    paddingBottom: { xs: 2, sm: 4, md: 6 },
                  },
                }}
              >
                <Box
                  component={Avatar}
                  variant="rounded"
                  width={84}
                  height={84}
                  marginBottom={2}
                  bgcolor={alpha(theme.palette.primary.main, 0.1)}
                  borderRadius={5}
                >
                  <Box color={theme.palette.primary.main}>
                    <item.Icon sx={{ fontSize: 48 }} />
                  </Box>
                </Box>
                <Typography variant="h6" gutterBottom fontWeight={500} align="center">
                  {item.title}
                </Typography>
                <Typography align="center" color="textSecondary">
                  {item.subtitle}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Values;
